import o from "react";
import m from "classnames";
import { u as i, D as f } from "./DarkModeProvider-xoZXm3ct.es.js";
import { I as k } from "./IconButton-CS2gSiMZ.es.js";
import { T as p } from "./Tooltip-B-bmRvX4.es.js";
import { T as u } from "./index-Dd-4N6BE.es.js";
import './Icon2.css';const v = "#000", I = "#fedb00", y = "#fff", b = "Icon-module__icon___q4s7E", E = "Icon-module__overlay___Ajz5l", M = "Icon-module__selected___c0xEY", w = "Icon-module__darkMode___rLtT7", h = "Icon-module__container___jJLOW", N = "Icon-module__label___OKXuE", e = {
  black: v,
  yellow: I,
  white: y,
  icon: b,
  overlay: E,
  selected: M,
  darkMode: w,
  container: h,
  label: N
}, T = ({
  onClick: s,
  label: r,
  selected: t = !1,
  name: _ = "favorites",
  overlay: c = !1,
  tooltipPlacement: d = "top"
}) => {
  const a = i(), l = a || c;
  return /* @__PURE__ */ o.createElement("div", { className: e.container }, /* @__PURE__ */ o.createElement(
    p.Hover,
    {
      dark: !a,
      trigger: /* @__PURE__ */ o.createElement(
        k,
        {
          className: m(
            e.icon,
            c && e.overlay,
            a && e.darkMode,
            t && e.selected
          ),
          name: _,
          onClick: (n) => {
            s(n), n.stopPropagation();
          },
          size: "1.25rem",
          color: l && !t ? e.white : e.black,
          alt_color: t ? e.yellow : void 0,
          hoverColor: l && !t ? e.black : void 0,
          label: r
        }
      ),
      placement: d,
      accessible: !1,
      short: !0
    },
    /* @__PURE__ */ o.createElement("div", { className: e.label }, /* @__PURE__ */ o.createElement(f, { darkMode: !a }, /* @__PURE__ */ o.createElement(u.Body2, { responsive: !0 }, r)))
  ));
};
T.displayName = "Icon";
export {
  T as I
};
